import { render, staticRenderFns } from "./AwardWrite.vue?vue&type=template&id=6c1f8b4c&scoped=true"
import script from "./AwardWrite.vue?vue&type=script&lang=js"
export * from "./AwardWrite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1f8b4c",
  null
  
)

export default component.exports